import { Translate } from '@chipinside/translate'
import { Button, IconButton, Tooltip } from '@mui/material'

import {
  BrowserUpdateTarget,
  SupportedBrowser,
  SystemUpdateButton,
} from '#/store/services/BrowserGuard/types'
import { BROWSER_ICON_SIZE, ButtonsRow } from '#/store/services/BrowserGuard/View/styles'
import Palette from '#/styles/Palette'

type Props = {
  iconButtonBrowsers: readonly SupportedBrowser[]
  matchedBrowser?: SupportedBrowser
  safariBrowser: SupportedBrowser
  systemUpdateButton: SystemUpdateButton | null
  updateTarget: BrowserUpdateTarget
}

function openBrowserDownloadPage(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function ActionButtons({
  iconButtonBrowsers,
  matchedBrowser,
  safariBrowser,
  systemUpdateButton,
  updateTarget,
}: Props) {
  return (
    <ButtonsRow>
      {systemUpdateButton && (
        <Button
          color="secondary"
          variant="outlined"
          size="large"
          startIcon={
            <img
              src={safariBrowser.icon}
              alt={systemUpdateButton.alt}
              width={BROWSER_ICON_SIZE}
              height={BROWSER_ICON_SIZE}
            />
          }
          sx={{
            borderColor: Palette.gray.self[400],
            borderRadius: 6,
            color: Palette.gray.dark[900],
          }}
          onClick={() => openBrowserDownloadPage(safariBrowser.url)}
        >
          {Translate({
            messageKey: systemUpdateButton.messageKey,
          })}
        </Button>
      )}

      {updateTarget === 'browser' && matchedBrowser && (
        <Tooltip
          title={Translate({
            messageKey: 'browser_guard_download_tooltip',
            params: {
              browser: matchedBrowser.label,
            },
          })}
        >
          <Button
            color="secondary"
            variant="outlined"
            size="large"
            startIcon={
              <img
                src={matchedBrowser.icon}
                alt={matchedBrowser.label}
                width={BROWSER_ICON_SIZE}
                height={BROWSER_ICON_SIZE}
              />
            }
            sx={{
              borderColor: Palette.gray.self[400],
              borderRadius: 6,
              color: Palette.gray.dark[900],
            }}
            onClick={() => openBrowserDownloadPage(matchedBrowser.url)}
          >
            {Translate({
              messageKey: 'browser_guard_download_tooltip',
              params: {
                browser: matchedBrowser.label,
              },
            })}
          </Button>
        </Tooltip>
      )}

      {iconButtonBrowsers.map(browser => (
        <Tooltip
          key={browser.key}
          title={Translate({
            messageKey: 'browser_guard_download_tooltip',
            params: {
              browser: browser.label,
            },
          })}
        >
          <IconButton
            aria-label={browser.label}
            onClick={() => openBrowserDownloadPage(browser.url)}
            sx={{
              backgroundColor: 'rgba(0,0,0,0.05)',
            }}
          >
            <img
              src={browser.icon}
              alt={browser.label}
              width={BROWSER_ICON_SIZE}
              height={BROWSER_ICON_SIZE}
            />
          </IconButton>
        </Tooltip>
      ))}
    </ButtonsRow>
  )
}
